import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { PrototypeProduct } from './prototype/pricing/pricing.module';
import { CommonModule } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthInterceptor, NoAuthInterceptor, TokenService } from '@auth';
import { LayoutModule } from './layout/layout.module';
import { TierModule } from './tier/tier/tier.module';
import { RestaurantItemModule } from './restaurant-item/restaurant-item/restaurant-item.module';
import { ReportsModule } from './reports/reports/reports.module';
import { AdminModule } from './admin/admin.module';

export function initializeApp(tokenService: TokenService): () => void {
  return () => tokenService.getToken();
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    LayoutModule,
    PrototypeProduct,
    TierModule,
    RestaurantItemModule,
    ReportsModule,
    AdminModule,
  ],
  providers: [
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NoAuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [TokenService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
